$(() => {
  $(document).ready(function() {
    if (location.hash === "#api-key") {
      $("html,body").scrollTop(0);
    }
  });
});
